import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class selfPickupsTableCtrl implements IController {

  selectedId: string;
  from: any;
  to: any;
  statuses: any;
  depotId: string;
  doReload: any;
  selfPickupsToAdd: any;
  onAddedSelfPickup: any;
  onSelect: Function;
  onReload: Function;
  onDelete: Function;
  onStatusChange: Function;
  onEdit: Function;
  onAddPackaging: Function;
  onSendMessage: Function;
  onPrint: Function;

  private selfPickupsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private $selfPickups, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.selfPickupsRef = this.$selfPickups();
    this.loadLimit = 30;

    this.selfPickupsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.selfPickupsRef, this.loadLimit);
  };

  $onChanges(changes) {
    if ((changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange())) {
      this._reloadQuery()
    }
    if (changes.statuses && !changes.statuses.isFirstChange()) {
      this._reloadQuery()
    }
    if (changes.depotId && !changes.depotId.isFirstChange()) {
      this._reloadQuery()
    }
    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._reloadQuery()
      }
    }
    if (changes.selfPickupsToAdd && !changes.selfPickupsToAdd.isFirstChange()) {
      if (this.selfPickupsToAdd && this.selfPickupsToAdd.length) {
        this._addItem(this.selfPickupsToAdd)
      }
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onActionSelect(selfPickup, action) {
    if (_.isEqual(action, 'Edit')) {
      this.onEdit({selfPickup: selfPickup})
    }
    if (_.isEqual(action, 'AddPackaging')) {
      this.onAddPackaging({selfPickup: selfPickup})
    }
    if (_.isEqual(action, 'SendMessage')) {
      this.onSendMessage({selfPickup: selfPickup})
    }
    if (_.isEqual(action, 'Print')) {
      this.onPrint({selfPickup: selfPickup})
    }
    if (_.isEqual(action, 'Cancel')) {
      this.onStatusChange({selfPickup: selfPickup, status: 'Cancel'})
    }
  }

  // ******************************
  //        Private methods
  // ******************************

  _reloadQuery() {
    this.selfPickupsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload()
      })
      .catch((response) => {
          this.$log.debug('Fail to $query', response);
        }
      );
  }

  _addItem(selfPickups) {
    this.infiniteScroll.addItems(_.map(selfPickups, 'id'));
    this.onAddedSelfPickup();
  }

  _getQueryPayload() {
    return {
      status: this.statuses || [],
      depotId: this.depotId,
      from: this.from,
      to: this.to,
      limit: this.loadLimit
    }
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupsTable', {
    bindings: {
      selectedId: '<',
      from: '<?',
      to: '<?',
      statuses: '<',
      depotId: '<',
      doReload: '<',
      selfPickupsToAdd: '<',
      onAddedSelfPickup: '&',
      onSelect: '&',
      onReload: '&',
      onDelete: '&',
      onStatusChange: '&',
      onEdit: '&',
      onAddPackaging: '&',
      onSendMessage: '&',
      onPrint: '&'
    },
    template: require('./self-pickups-table.html').default,
    controller: selfPickupsTableCtrl
  });
